// frontend/my-react-app/src/pages/LandingPage.jsx
// Created: 2026-03-14
// Updated: 2026-03-10 — hero features converted from bullet list to paragraph
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';

export default function LandingPage() {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const scriptUrl = process.env.REACT_APP_WAITLIST_SCRIPT_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const email = form.email?.value?.trim();

    if (!email) return;

    setSubmitting(true);
    setError(null);

    try {
      if (scriptUrl) {
        await fetch(scriptUrl, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email,
            timestamp: new Date().toISOString(),
          }),
        });
      }
      setSubmitted(true);
      form.querySelectorAll('input, button').forEach((el) => (el.disabled = true));
    } catch (err) {
      setError('Something went wrong — please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="landing-page">
      <section className="landing-hero">
        <div className="landing-hero-left">
          <div className="landing-logo">barking meds</div>
          <div className="landing-hero-content">
            <div className="landing-h1-wrapper">
              <h1>Never forget Fido&apos;s meds again.</h1>
            </div>
            <p className="landing-hero-copy">
            Caring for your pet shouldn't be stressful. 
            Get personalized WhatsApp reminders, track medications and side effects, 
            and manage all your pets in one place—no downloads required.* </p>
            <p className="landing-hero-copy">Join as an Early Member and get 
              free lifetime access.
            </p>
            <div className="landing-hero-form-wrapper">
              <h2 className="landing-form-title">REQUEST EARLY ACCESS</h2>
              <form className="landing-hero-form" onSubmit={handleSubmit}>
                <div className="landing-form-inline">
                  <input
                    className="landing-form-input"
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Enter your email"
                    required
                  />
                  <button
                    type="submit"
                    className="landing-submit-btn"
                    disabled={submitting || submitted}
                  >
                    {submitting ? 'Submitting…' : submitted ? 'Request Sent ✓' : 'SUBMIT'}
                  </button>
                </div>
                {error && <p className="landing-form-error">{error}</p>}
              </form>
            </div>
          </div>
          <div className="landing-hero-footer">
            <img
              className="landing-pills-bottom"
              src="/pills-trio.png"
              alt=""
            />
            <p className="landing-hero-footnote">* If you already have WhatsApp.</p>
          </div>
        </div>
        <div className="landing-hero-right">
          <img
            className="landing-pets"
            src="/hero-pets-landing.png"
            alt="A cat, poodle and corgi"
          />
        </div>
      </section>

      <footer className="landing-footer">
        <Link to="/sign-in" className="landing-footer-sign-in">
          Already have access? SIGN IN →
        </Link>
        <span className="landing-footer-legal">2026 AlohaVida LLC (dba BarkingMeds.com)</span>
      </footer>
    </div>
  );
}
